<template>
  <section class="og-home-hero" aria-labelledby="og-hero-title">
    <div class="og-home-hero__bg" aria-hidden="true" />
    <div class="og-home-hero__inner">
      <div class="og-home-hero__grid">
        <div class="og-home-hero__copy">
          <p class="og-home-hero__kicker">OG WhatsApp · Android</p>
          <p class="og-home-hero__badge" aria-hidden="true">
            <span class="og-home-hero__badge-pill">2026 Guide</span>
            <span class="og-home-hero__badge-dot">·</span>
            <span>OG WhatsApp APK</span>
          </p>
          <h1 id="og-hero-title" class="og-home-hero__title" itemprop="headline">
            OG WhatsApp Download | Latest Version APK for 2026
          </h1>
          <p class="og-home-hero__subtitle">
            OG WhatsApp is an unofficial Android mod for people who want a little more control than the standard WhatsApp experience offers. Users usually look for features like extra privacy options, dual-account support on compatible builds, and more customization tools.
          </p>
          <div class="og-home-hero__actions">
            <router-link class="og-home-hero__cta" :to="{ name: 'en-download' }">
              Download OG WhatsApp APK
            </router-link>
            <router-link class="og-home-hero__secondary" :to="{ name: 'en-compare-og-gb' }">
              OG WhatsApp vs GB WhatsApp
            </router-link>
          </div>
        </div>

        <div class="og-home-hero__visual">
          <div class="og-home-hero__visual-card">
            <img
              src="@/assets/og-whatsapp-logo.png"
              width="220"
              height="220"
              alt="OG WhatsApp app icon"
              class="og-home-hero__logo"
              loading="eager"
              fetchpriority="high"
            />
          </div>
        </div>

        <div class="og-home-hero__stats-wrap">
          <div class="og-home-hero__meta-stack">
            <p class="og-home-hero__fineprint">
              Third-party mod · Not the official app ·
              <router-link class="og-home-hero__fineprint-link" :to="{ name: 'en-disclaimer' }">Disclaimer</router-link>
            </p>
            <div class="og-home-hero__stats" role="list">
              <div class="og-home-hero__stat" role="listitem">
                <span class="og-home-hero__stat-label">App</span>
                <span class="og-home-hero__stat-value">OG WhatsApp</span>
              </div>
              <div class="og-home-hero__stat" role="listitem">
                <span class="og-home-hero__stat-label">File size</span>
                <span class="og-home-hero__stat-value">80 MB</span>
              </div>
              <div class="og-home-hero__stat" role="listitem">
                <span class="og-home-hero__stat-label">Rating</span>
                <span class="og-home-hero__stat-value">4.3</span>
              </div>
              <div class="og-home-hero__stat" role="listitem">
                <span class="og-home-hero__stat-label">Android</span>
                <span class="og-home-hero__stat-value">5.0+</span>
              </div>
              <div class="og-home-hero__stat" role="listitem">
                <span class="og-home-hero__stat-label">Updated</span>
                <span class="og-home-hero__stat-value">2 days ago</span>
              </div>
              <div class="og-home-hero__stat" role="listitem">
                <span class="og-home-hero__stat-label">Version</span>
                <span class="og-home-hero__stat-value">18.70</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'OgHomeHero',
};
</script>

<style lang="scss" scoped>
/* 首屏：铺满屏宽（独立于首页 .container）；内层栅格仍居中限宽 */
.og-home-hero {
  position: relative;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  padding: 2rem 0 2.5rem;
  margin: 0;
  overflow: hidden;
}

.og-home-hero__bg {
  position: absolute;
  inset: 0;
  background: linear-gradient(165deg, #f4faf8 0%, #ffffff 55%, #ffffff 100%);
  z-index: 0;
}

.og-home-hero__bg::after {
  content: '';
  position: absolute;
  right: -20%;
  top: -30%;
  width: 55%;
  height: 120%;
  background: radial-gradient(
    ellipse at center,
    rgba(32, 79, 70, 0.08) 0%,
    transparent 70%
  );
  pointer-events: none;
}

.og-home-hero__inner {
  position: relative;
  z-index: 1;
  width: 100%;
  max-width: 1100px;
  margin: 0 auto;
  padding-left: max(16px, env(safe-area-inset-left));
  padding-right: max(16px, env(safe-area-inset-right));
  box-sizing: border-box;
}

.og-home-hero__grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 2rem;
  align-items: center;
}

@media (min-width: 900px) {
  .og-home-hero__grid {
    grid-template-columns: 1fr minmax(260px, 340px);
    gap: 3rem;
    row-gap: 2rem;
  }

  /* 统计卡片区独占一行并相对整栏居中 */
  .og-home-hero__stats-wrap {
    grid-column: 1 / -1;
  }
}

.og-home-hero__kicker {
  margin: 0 0 0.5rem;
  font-size: 0.8125rem;
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #204f46;
}

.og-home-hero__badge {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.35rem;
  margin: 0 0 0.65rem;
  font-size: 0.875rem;
  font-weight: 600;
  color: #333333;
}

.og-home-hero__badge-pill {
  display: inline-block;
  padding: 0.2rem 0.55rem;
  border-radius: 6px;
  background: rgba(32, 79, 70, 0.1);
  color: #204f46;
  font-size: 0.8rem;
}

.og-home-hero__badge-dot {
  opacity: 0.45;
}

.og-home-hero__title {
  margin: 0 0 0.75rem;
  font-size: clamp(1.75rem, 4vw, 2.35rem);
  font-weight: 800;
  line-height: 1.15;
  color: #204f46;
  letter-spacing: -0.02em;
}

.og-home-hero__subtitle {
  margin: 0 0 1.25rem;
  font-size: 1.05rem;
  line-height: 1.6;
  color: #333333;
  max-width: 38rem;
}

.og-home-hero__actions {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 1.75rem;
}

.og-home-hero__cta {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 14px 28px;
  border-radius: 4px;
  font-size: 1rem;
  font-weight: 700;
  color: #ffffff !important;
  text-decoration: none !important;
  background: #204f46;
  border: none;
  box-shadow: none;
  transition: background 0.2s ease, transform 0.2s ease;
}

.og-home-hero__cta:hover {
  transform: translateY(-2px);
  background: #34d399 !important;
  color: #ffffff !important;
}

.og-home-hero__secondary {
  display: inline-flex;
  align-items: center;
  padding: 12px 22px;
  border-radius: 4px;
  font-size: 0.95rem;
  font-weight: 600;
  color: #204f46 !important;
  text-decoration: none !important;
  border: 1px solid #e5e5e5;
  background: #ffffff;
  transition: border-color 0.2s ease, background 0.2s ease;
}

.og-home-hero__secondary:hover {
  border-color: #34d399;
  background: #ffffff;
}

.og-home-hero__fineprint {
  margin: 0;
  width: 100%;
  text-align: center;
  font-size: 0.78rem;
  color: #444444;
  line-height: 1.45;
}

.og-home-hero__fineprint-link {
  color: #204f46 !important;
  font-weight: 600;
  text-decoration: none !important;
  text-underline-offset: 2px;
}

.og-home-hero__fineprint-link:hover {
  color: #34d399 !important;
  text-decoration: underline !important;
  text-decoration-thickness: 1px;
}

/* 免责声明 + 六格卡：同一列限宽容器，整列在首屏内水平居中 */
.og-home-hero__stats-wrap {
  width: 100%;
  display: flex;
  justify-content: center;
  box-sizing: border-box;
}

.og-home-hero__meta-stack {
  width: 100%;
  max-width: 720px;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 0.75rem;
}

.og-home-hero__stats {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px;
  width: 100%;
}

@media (min-width: 520px) {
  .og-home-hero__stats {
    grid-template-columns: repeat(3, 1fr);
  }
}

.og-home-hero__stat {
  background: #fff;
  border-radius: 12px;
  padding: 12px 14px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
  border: 1px solid #e5e5e5;
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-height: 72px;
}

.og-home-hero__stat-label {
  font-size: 0.7rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #444444;
}

.og-home-hero__stat-value {
  font-size: 0.9rem;
  font-weight: 700;
  color: #333333;
  line-height: 1.3;
}

.og-home-hero__visual {
  display: flex;
  justify-content: center;
  align-items: center;
}

.og-home-hero__visual-card {
  background: #fff;
  border-radius: 24px;
  padding: 2rem 2.25rem;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.08);
  border: 1px solid #e5e5e5;
}

.og-home-hero__logo {
  display: block;
  width: min(220px, 70vw);
  height: auto;
  margin: 0 auto;
  filter: drop-shadow(0 8px 24px rgba(32, 79, 70, 0.18));
}

@media (max-width: 899px) {
  .og-home-hero__visual {
    order: -1;
  }

  .og-home-hero__visual-card {
    padding: 1.5rem 1.75rem;
  }
}
</style>
